#
# This method initialises the typeahead for all elements with a "data-typeahead" attribute.
#
$(document).ready(() ->
    # Loop over all elements with the "data-typeahead" attribute.
    $('[data-typeahead]').each((index) ->
        $(this).initTypeahead()
    )
)

$.fn.initTypeahead = () ->
    # Read the arguments.
    args = $(this).data('typeahead').split(':')
    multiple = null
    if $(this).data('multipleId')?
        multiple = $("##{$(this).data('multipleId')}")
    method = args[0]
    source = args[1]
    #display = args[2]

    # See Bloodhound documentation for the different methods.
    # Only "remote" and "prefetch" are supported right now.
    switch method
        when "prefetch"
            if $(this).data('typeahead-cache')?
                cache = Boolean($(this).data('typeahead-cache'))
            else
                cache = true

            data = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace
                queryTokenizer: Bloodhound.tokenizers.whitespace
                prefetch: {
                    url: baseurl + '/' + source,
                    cache: cache
                }
            })
        when "remote"
            sources = source.split(',')

            data = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace
                queryTokenizer: Bloodhound.tokenizers.whitespace
                prefetch: baseurl + '/' + sources[0]
                remote: {
                    url: baseurl + '/' + sources[1]
                    wildcard: '%QUERY'
                }
            })
        else throw 37

    # Initialise typeahead on the element.
    $(this).typeahead(null, {
        name: $(this).attr('name')
        source: data
        #display: display
    })
    if multiple
        f = (evt, item) ->
            if multiple.val() is ''
                multiple.val(item)
            else
                multiple.val("#{multiple.val()}, #{item}")
            $(this).typeahead('val', '')
            if $(this).attr('id')
                setTimeout("$('##{$(this).attr('id')}').focus();", 0)
        $(this).on('typeahead:selected', f)
        $(this).on('typeahead:autocompleted', f)
